import { getClient } from 'entity/LaudoVisita/components/LaudoVisitaConsultaRelatorios/functions'
import _ from 'lodash'

export default async function LCGraficoExtraRelatorio(
    content,
    h,
    mediaAgrupadorList,
    metaUsar,
    IndicadorEntity,
    groupByConfig,
    apontamentos,
    paramsCliente,
    dataInicio,
    dataFim,
) {
    let grupo = mediaAgrupadorList[0]

    // obtém média de adultas e verifica o status
    let mediaAdultas = _.meanBy(grupo.apontamentos, (a) => parseFloat(_.get(a, 'numAdultasMetro', 0)))
    grupo.mediaAdultas = mediaAdultas.toFixed(2) // conformidade adultas por metro
    if (paramsCliente) { // status e cor adultas por metro
        grupo.statusAdultas = IndicadorEntity.getConformidadeStatus(mediaAdultas, paramsCliente.metaMaxAdultas, null, getClient())
        grupo.colorAdultas = IndicadorEntity.getColorStatus(grupo.statusAdultas)
    }

    content.push(
        h.pageBreak(),
        h.panel(
            [
                h.row(
                    h.title('Adultas', { fontSize: 12 }),
                ),
            ],
            { widths: ["*"], unbreakable: true }
        ),
        h.tablePanel([
            { title: "Agrupador", value: groupByConfig.nome },
            { title: "Meta Adultas", value: paramsCliente?.metaMaxAdultas || '' },
            { title: "Data de Início", value: dataInicio },
            { title: "Data de Fim", value: dataFim },
        ]),
        h.panel(
            [
                h.row(
                    await h.chart(
                        "CardIndicadorProps",
                        {
                            xField: "groupNameShow",
                            yField: "mediaAdultas",
                            data: mediaAgrupadorList,
                            meta: parseFloat(paramsCliente?.metaMaxAdultas),
                            width: 525,
                            height: 400,
                            color: mediaAgrupadorList.map(m => m.colorAdultas),
                            colorFieldPath: 'colorAdultas'
                        },
                        { alignment: "center" }
                    ),
                ),
            ],
            { widths: ["*"], unbreakable: true, layout: "borders" }
        ),
        h.tablePanel(
            [
                { title: groupByConfig.nome, field: "groupNameShow" },
                { title: "Média", field: "mediaAdultas" },
                { title: "Status", field: "statusAdultas" },
            ],
            mediaAgrupadorList
        ),
    )
}